import common from './common';
import insurance from './insurance';

const all = {
	...insurance,
	...common
};

export default all;
